import i18n from "../i18n";

export function formatDate(dateStr: string): string {
  const date = dateStr.includes("T")
    ? new Date(dateStr)
    : new Date(`${dateStr}T00:00:00`);
  return new Intl.DateTimeFormat(i18n.language, {
    month: "short",
    day: "numeric",
  }).format(date);
}

export function formatDateTime(dateStr: string): string {
  const date = dateStr.includes("T")
    ? new Date(dateStr)
    : new Date(`${dateStr}T00:00:00`);
  return new Intl.DateTimeFormat(i18n.language, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

export function formatRelativeDate(dateStr: string): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(`${dateStr}T00:00:00`);
  const diffDays = Math.floor(
    (target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffDays === 0) return i18n.t("common:date.today");
  if (diffDays === 1) return i18n.t("common:date.tomorrow");
  if (diffDays === -1) return i18n.t("common:date.yesterday");
  if (diffDays > 1) return i18n.t("common:date.daysLater", { count: diffDays });
  return i18n.t("common:date.daysAgo", { count: Math.abs(diffDays) });
}
